import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CompanyAuditReportDto, UpsertAuditReportRequest } from '../../models/api/companyAuditReportDto';
import { YearlyResource } from '../../models/api/yearlyResource';

@Injectable({
  providedIn: 'root'
})
export class CompanyAuditReportService {
  private apiUrl = `${environment.apiUrl}/companies`;

  constructor(private http: HttpClient) {}

  get(companyId: string, year?: number): Observable<YearlyResource<CompanyAuditReportDto>> {
    let params = new HttpParams();
    if (year !== undefined) {
      params = params.set('year', year.toString());
    }
    return this.http.get<YearlyResource<CompanyAuditReportDto>>(
      `${this.apiUrl}/${companyId}/audit-reports`,
      { params }
    );
  }

  upsert(companyId: string, request: UpsertAuditReportRequest): Observable<CompanyAuditReportDto> {
    return this.http.put<CompanyAuditReportDto>(`${this.apiUrl}/${companyId}/audit-reports`, request);
  }

  delete(companyId: string, year?: number): Observable<void> {
    let params = new HttpParams();
    if (year !== undefined) {
      params = params.set('year', year.toString());
    }
    return this.http.delete<void>(`${this.apiUrl}/${companyId}/audit-reports`, { params });
  }
}
